<template>
    <div class="registry-wrapper">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="columns">
            <div
                class="column"
                :class="[
                    permissaoVincular && permissaoCadastrar
                        ? 'is-4'
                        : permissaoVincular || permissaoCadastrar
                        ? 'is-6'
                        : 'is-8',
                ]"
            >
                <search-bar
                    :onSearch="debouncedOnSearch"
                    tooltipLabel="msg-campo-busca-forma-pagamento"
                />
            </div>
            <div
                class="column"
                :class="[
                    permissaoVincular && permissaoCadastrar
                        ? 'is-2'
                        : permissaoVincular || permissaoCadastrar
                        ? 'is-3'
                        : 'is-4',
                ]"
            >
                <vss-select
                    ref="situacaoSelect"
                    :searchable="false"
                    :options="situacaoSelect"
                    v-model="situacaoSelected"
                    mlLabels
                    title="situacao"
                    clearable
                    @input="onSituacaoChanged"
                    :height="40"
                />
            </div>
            <div class="column is-3" v-if="permissaoVincular">
                <button class="save-btn botao-acao" type="button" @click="showModal = !showModal">
                    {{ $t('vincular-forma-pagamento') }}
                </button>
            </div>
            <div class="column is-3" v-if="permissaoCadastrar">
                <button
                    class="save-btn botao-acao"
                    type="button"
                    @click="showModalCadastroFormaPagamento"
                >
                    {{ $t('adicionar-forma-pagamento') }}
                </button>
            </div>
        </div>
        <div class="registry-wrapper">
            <empty-table-message v-if="isEmpty" />
            <b-table
                v-else
                :data="assformapagtoclientelist"
                class="data-table"
                @sort="sortTable"
                backend-sorting
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="f.key != 'excluir' ? $t(f.key) : ''"
                    :width="f.width"
                    :class="{
                        'excluir-field': f.key == 'excluir',
                    }"
                    :sortable="f.sortable"
                    :custom-sort="f.sortFn"
                    v-slot="props"
                >
                    <div v-if="f.key == 'excluir'">
                        <b-button
                            v-if="permissao.update && !assFormaPagtoClienteIntegracao"
                            class="action-button"
                            :type="props.row['replicapda'] == 3 ? 'is-danger' : 'is-success'"
                            :icon-right="props.row['replicapda'] == 3 ? 'delete' : 'check'"
                            @click="promptChangeSituacao(props.row)"
                            v-tippy
                            :title="$t(props.row['replicapda'] == 3 ? 'desativar' : 'reativar')"
                        />
                    </div>

                    <div v-else-if="f.key == 'data-hora'">
                        {{ props.row[f.key] | moment('DD/MM/YYYY HH:mm:ss') }}
                    </div>
                    <div v-else-if="f.key == 'replicapda'">
                        <b-tag
                            class="table-tag table-tag-full-width"
                            :type="props.row['replicapda'] == 3 ? 'is-success' : 'is-danger'"
                            size="is-medium"
                        >
                            {{ $t(props.row['replicapda'] == 3 ? 'ativo' : 'inativo') }}
                        </b-tag>
                    </div>
                    <div v-else>
                        {{ props.row[f.key] }}
                    </div>
                </b-table-column>
            </b-table>
            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
        <!-- MODAL DE ASSOCIACAO -->
        <b-modal :active.sync="showModal" @fecharModal="fecharModal">
            <div class="bg">
                <FormaPagamentoSelectModal
                    :idCliente="$route.params.id"
                    @fecharModal="fecharModal"
                    @selected="selected"
                />
            </div>
        </b-modal>
        <!-- MODAL DE CADASTRO FORMA DE PAGAMENTO -->
        <b-modal :active.sync="modalCadastroFormaPagamento">
            <div>
                <FormaPagamentoCadastroModal
                    @fecharModal="fecharModal"
                    :idCliente="$route.params.id"
                    :permissaoVincular="!assFormaPagtoClienteIntegracao"
                    @cadastrado="cadastrado"
                />
            </div>
        </b-modal>
    </div>
</template>

<script>

// SERVICES
import AssFormaPagamentoCliente from '@/services/vendas/cliente/abas/AssFormaPagamentoClienteService';
import FormaPagamentoSelectModal from '@/components/vendas/cliente/modal/FormaPagamentoSelectModal.vue';
import FormaPagamentoCadastroModal from '@/components/vendas/cliente/modal/FormaPagamentoCadastroModal.vue';

// COMPONENTS
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    props: {
        data: {
            type: Object,
            default: () => {},
        },
    },
    components: {
        ContainerLoader,
        FormaPagamentoSelectModal,
        FormaPagamentoCadastroModal,
    },
    data() {
        return {
            assFormaPagtoClienteIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'ASSFORMAPAGTOCLIENTE'
            ),
            formaPagtoIntegracao: this.$store.state.user.tabelasERPWebServer.includes('FORMAPAGTO'),
            assformapagtoclientelist: [],
            fields: [
                { key: 'codigo', width: null, sortable: true, sortFn: null },
                { key: 'forma-pagamento', width: null, sortable: true, sortFn: null },
                { key: 'data-hora', width: null, sortable: false, sortFn: null },
                { key: 'replicapda', width: 80, sortable: true, sortFn: null },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],

            service: new AssFormaPagamentoCliente(this.$http, this.$router),
            permissao: false,
            permissaoUsuario: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            situacaoSelected: { id: 4, label: 'todos' },
            situacaoSelect: [
                { id: 4, label: 'todos' },
                { id: 3, label: 'ativos' },
                { id: 2, label: 'inativos' },
            ],

            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'forma-pagamento',
            order: 'asc',
            isSaving: false,
            delete: null,
            showModal: false,
            modalCadastroFormaPagamento: false,
            modalManage: false,
            assformapagtoclietne: null,
            //permissoes relativas à exibição dos botões
            permissaoVincular: false,
            permissaoCadastrar: false,

            isVenda: this.$route.meta.contexto == 'vendas',
            isAgro: this.$route.meta.contexto == 'agro',
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                'vendas',
                'clientes',
                'ven-cliente-politica-comercial-forma-pagamento'
            );
        } else if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
            this.permissao = this.hasPermissionAccess(
                'agro',
                'clientes',
                'agro-cliente-politica-comercial-forma-pagamento'
            );
        }

        this.permissaoCadastroFormaPagto = this.hasPermissionAccess(
            'vendas',
            'vendas',
            'ven-forma-pagamento'
        );

        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess('vendas', 'clientes', 'ven-forma-pagamento');
        } else if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
            this.permissao = this.hasPermissionAccess('agro', 'clientes', 'agro-forma-pagamento');
        }

        this.permissaoVincular = this.permissao.create && !this.assFormaPagtoClienteIntegracao;
        this.permissaoCadastrar =
            this.permissaoCadastroFormaPagto.create && !this.formaPagtoIntegracao;

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'clientes' },
            });
        } else {
            this.carregarDados();
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        }
    },
    methods: {
        showMessage(type, message) {
            let data = {
                type: type,
                message: message,
            };

            this.$emit('alert', data);
        },
        loadPage(pageNumber) {
            let query = {
                page: pageNumber,
                limit: this.data.perPage,
                column: this.column,
                order: this.order,
            };

            this.$emit('load-page', query);
        },
        loadSort(field, order) {
            this.column = field;
            this.order = order;

            this.loadPage(this.data.page);
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.findAll(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                this.situacaoSelected.id,
                this.$route.params.id,
                this.queryFilter
            )
                .then(this.mapItems)
                .then((value) => {
                    this.assformapagtoclientelist = value;
                    this.isEmpty = this.assformapagtoclientelist.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar as tabelas de preços.');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        findAll(column, order, page, limit, situacao, idcliente, ...params) {
            if (this.isVenda) {
                return this.service.findAllVendas(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    idcliente,
                    ...params
                );
            } else {
                return this.service.findAllAgro(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    idcliente,
                    ...params
                );
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    idassformapagtocliente: m.idassformapagtocliente,
                    codigo: m.formapagto.idformapagtoerp,
                    idformapagto: m.formapagto.idformapagto,
                    'forma-pagamento': m.formapagto.descricao,
                    'data-hora': m.datahorainc,
                    replicapda: m.replicapda,
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 3
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row['forma-pagamento'] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.replicapda == 3
                    ? 'msg-erro-ao-reativar-associacao-forma-pagamento'
                    : 'msg-erro-ao-desativar-associacao-forma-pagamento';

            let tempAssformapagtocliente = {
                idassformapagtocliente: this.delete.idassformapagtocliente,
                replicapda: this.delete.replicapda == 3 ? 2 : 3,
            };

            this.isLoading = true;

            this.updateSituacao(tempAssformapagtocliente)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.replicapda == 3
                                ? 'msg-sucesso-ao-reativar-associacao-forma-pagamento'
                                : 'msg-sucesso-ao-desativar-associacao-forma-pagamento';
                        this.$root.showMessage('success', tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        updateSituacao(assformapagtocliente) {
            if (this.isVenda) return this.service.updateSituacaoVendas(assformapagtocliente);
            else return this.service.updateSituacaoAgro(assformapagtocliente);
        },
        showModalCadastroFormaPagamento() {
            this.modalCadastroFormaPagamento = !this.modalCadastroFormaPagamento;
        },
        fecharModal() {
            this.showModal = false;
            this.modalManage = false;
            this.modalCadastroFormaPagamento = false;
            this.carregarDados();
        },
        selected(selected) {
            this.modalManage = true;
            this.assformapagtocliente = selected;
        },
        selectedEdit(selected) {
            this.modalManage = true;
            this.assformapagtocliente = selected;
            this.showModal = true;
        },
        cadastrado() {
            this.modalCadastroFormaPagamento = false;
            this.carregarDados();
        },
    },
};
</script>
<style lang="scss" scoped>
.botao-acao {
    margin-top: 24px;
    width: 100%;
    height: 40px;
}

@media (max-width: 760px) {
    .search-bar {
        padding-bottom: 0.4rem;
    }
    .botao-acao {
        margin-top: 0;
    }
}
</style>
